import React from "react";
import styled, { css } from "styled-components";
import { px2rem } from "utils/browser/resizer";
import { lsSetItem, lsGetItem, lsRemoveItem } from "utils/safeWebStorage";
import getLangKeyValueFun from "utils/lang";
import { AssetImageUrl } from "assets/imgUrls";
import { getKeywordSearch, getTopKeywords } from "headFootServices/header/header";
import Constant, { Host } from "utils/headFootConstants";
import langGroup from "assets/lang.json";
import { OnSentryCatchParam } from "utils/sentryEvent";
import { Color } from "config/index";

const gettext = getLangKeyValueFun(langGroup);
let timeoutId = null;

const Container = styled.div`
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	z-index: 3000;
	background: #ffffff;
	font-size: ${px2rem(14)};
	color: #333333;
	padding-top: ${px2rem(50)};
`;
const Header = styled.div`
	display: flex;
	align-items: center;
	position: fixed;
	top: 0;
	width: 100%;
	height: ${px2rem(50)};
	background: #eee;
	border-top: 1px solid #ddd;
	border-bottom: 1px solid #ddd;
	padding-right: ${px2rem(9)};
	z-index: 10;
	box-sizing: border-box;
`;
const Close = styled.div`
	width: ${px2rem(45)};
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;
const SearchItem = styled.form`
	flex: 1;
	height: ${px2rem(34)};
	border-radius: ${px2rem(4.5)};
	border: 1px solid #bfbfbf;
	position: relative;
	> input {
		width: 100%;
		height: ${px2rem(32)};
		padding: 0 ${px2rem(40)} 0 ${px2rem(5)};
		border: none;
		color: #333;
		border-radius: ${px2rem(4.5)};
		font-size: ${px2rem(12)};
		box-sizing: border-box;
		outline: none;
	}
`;
const Inputdelete = styled.img`
	position: absolute;
	right: ${px2rem(40)};
	top: 50%;
	cursor: pointer;
	transform: translateY(-50%);
`;
const SearchButton = styled.button`
	position: absolute;
	right: 0;
	top: 0;
	width: ${px2rem(34)};
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background: -moz-linear-gradient(top, #fff, #f0f0f0);
	background: -webkit-gradient(linear, top, from(#fff), to(#f0f0f0));
	background: -webkit-linear-gradient(top, #fff, #f0f0f0);
	background: -o-linear-gradient(top, #fff, #f0f0f0);
	border: none;
	border-left: 1px solid #bfbfbf;
	border-radius: 0 ${px2rem(4.5)} ${px2rem(4.5)} 0;
	outline: none;
`;
const SearchKey = styled.div`
	position: absolute;
	top: 0;
	width: 100%;
	height: 100%;
	padding: 0 ${px2rem(16)};
	background: #ffffff;
	box-sizing: border-box;
	padding-top: ${px2rem(52)};
	overflow-y: scroll;
	overflow-x: hidden;
	> div {
		margin-top: ${px2rem(12)};
	}
`;
const RecentHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: ${px2rem(17)};
	> span {
		font-weight: 800;
	}
`;
const HistoryKeys = styled.div`
	> div {
		display: inline-block;
		padding: ${px2rem(3)} ${px2rem(7)};
		margin: 0 ${px2rem(13)} ${px2rem(20)} 0;
		background-color: #f2f2f2;
		border: #d1d1d1 1px solid;
		color: #333;
	}
`;
const TopList = styled.div`
	padding-bottom: ${px2rem(100)};
	> div {
		display: flex;
		align-items: center;
		margin-bottom: ${px2rem(17)};
	}
`;
const WorldsArrow = styled.img`
	transform: rotate(-20deg);
`;
const TopIndex = styled.div`
	width: ${px2rem(18)};
	height: ${px2rem(18)};
	line-height: ${px2rem(18)};
	font-size: ${px2rem(12)};
	background-color: #d1d1d1;
	border-radius: ${px2rem(4.5)};
	margin-right: ${px2rem(12)};
	text-align: center;
	color: #fff;
	${(props: { red: boolean }) =>
		props.red &&
		css`
			background-color: ${Color.Main};
		`};
`;
const Words = styled.div`
	flex: 1;
`;
const Clear = styled.div`
	display: flex;
	align-items: center;
	color: #888;
	> img {
		margin-right: ${px2rem(4.5)};
	}
`;
const ResultList = styled.div`
	position: absolute;
	top: 0;
	width: 100%;
	height: 100%;
	background: #ffffff;
	box-sizing: border-box;
	padding-top: ${px2rem(52)};
	padding-bottom: ${px2rem(100)};
	overflow-y: scroll;
	overflow-x: hidden;
	> div {
		display: flex;
		align-items: center;
		width: 100%;
		height: ${px2rem(45)};
		border-bottom: 1px solid #d1d1d1;
		padding: 0 ${px2rem(15)};
		font-size: ${px2rem(16)};
	}
`;
const LocalIcon = styled.img`
	margin-right: ${px2rem(10)};
`;
const AutoWords = styled.div`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	flex: 1;
`;

interface SearchProps {
	stateChange: (key, value) => void;
	onSentryCatch?: (params: OnSentryCatchParam) => void;
}
interface SearchState {
	showResult: boolean;
	searchText: string;
	topKeyWords: any[];
	keywords: any[];
	recentSearchList: string[];
}
class Search extends React.Component<SearchProps, SearchState> {
	constructor(props) {
		super(props);
		this.state = {
			showResult: false,
			searchText: "",
			recentSearchList: [],
			topKeyWords: [],
			keywords: [],
		};
	}

	componentDidMount() {
		// 获取搜索热词列表
		getTopKeywords({ category_id: 0 }, { onSentryCatch: this.props.onSentryCatch })
			.then((res: any) => {
				const topKeyWords = res.info || [];
				this.setState({ topKeyWords: topKeyWords.slice(0, 10) });
			})
			.catch((err) => {
				console.log(err);
			});
	}

	searchInput = (e) => {
		this.setState(
			{
				searchText: e.target.value || "",
			},
			() => {
				clearTimeout(timeoutId);
				// 为空时 关闭模糊搜索列表
				if (this.state.searchText === "") {
					this.setState({ showResult: false });
					return;
				} else {
					timeoutId = setTimeout(() => {
						this.autocomplete();
					}, 200);
				}
			},
		);
	};

	clearInput = () => {
		this.setState({
			searchText: "",
			showResult: false,
		});
	};

	handleSearch = (e) => {
		e.preventDefault();
		const { searchText } = this.state;
		if (searchText === "") {
			return;
		}
		// 存本次搜索到localstorage
		let list = [];
		try {
			list = JSON.parse(lsGetItem("RECENT_SEARCH_LIST")) || [];
		} catch (e) {
			list = [];
		}
		if (!list.some((preItem) => preItem === searchText)) {
			list.push(searchText);
			lsSetItem("RECENT_SEARCH_LIST", JSON.stringify(list));
		}
		lsSetItem("RECENT_SEARCH_LIST", JSON.stringify(list));
		this.goSearch(searchText);
	};

	goSearch = (val, queryType = "1") => {
		const BaseUrl = Host[String(Constant.isUat)];
		window.location.href = `${BaseUrl.mHost}/${Constant.language}/search?q=${val}&queryType=${queryType}`;
	};
	setRecentSearchList = () => {
		if (this.state.searchText && 0 in this.state.recentSearchList) {
			return;
		}
		if (!this.state.searchText) {
			// 取出历史搜索记录
			let recentSearchList = [];
			try {
				recentSearchList = JSON.parse(lsGetItem("RECENT_SEARCH_LIST")) || [];
			} catch (e) {
				recentSearchList = [];
			}
			recentSearchList = [...recentSearchList].reverse().slice(0, 6);
			recentSearchList = Array.from(new Set([...recentSearchList]));
			this.setState({ recentSearchList });
		} else {
			this.setState({ recentSearchList: [] });
		}
	};
	// 模糊搜索提示
	autocomplete = () => {
		getKeywordSearch(
			{
				word: this.state.searchText,
				num: 10,
			},
			{ onSentryCatch: this.props.onSentryCatch },
		)
			.then((res: any) => {
				if (this.state.searchText !== "") {
					let { keywords = [] } = res.info || [];
					const localResult = [];
					// 模糊搜索也要把本地的历史记录加进来
					this.state.recentSearchList.map((item) => {
						if (item.indexOf(this.state.searchText) === 0) {
							localResult.push({ keyword: item, isLocalHistory: true });
						}
					});
					if (localResult.length > 0) {
						keywords = localResult.concat(keywords);
					}
					this.setState({
						keywords,
						showResult: true,
					});
				}
			})
			.catch((err) => {
				console.log(err);
			});
	};

	clearRecent = () => {
		lsRemoveItem("RECENT_SEARCH_LIST");
		this.setState({ recentSearchList: [] });
	};

	render() {
		const { showResult, searchText, topKeyWords, recentSearchList, keywords } = this.state;
		const { stateChange } = this.props;
		return (
			<Container>
				<Header>
					<Close onClick={() => stateChange("showSearchModal", false)}>
						<img src={AssetImageUrl["ic_closed2@3x.png"]} width={18} />
					</Close>
					<SearchItem
						action="javascript:"
						accept-charset="utf-8"
						id="search_form"
						method="get"
						onSubmit={this.handleSearch}
					>
						<input
							name="q"
							id="q"
							value={searchText}
							autoComplete={"off"}
							placeholder={gettext("Search")}
							onChange={this.searchInput}
							onFocus={this.setRecentSearchList}
							type="search"
						/>
						{searchText !== "" && (
							<Inputdelete
								src={AssetImageUrl["ic_deleted@3x.png"]}
								width={18}
								onClick={this.clearInput}
							/>
						)}
						<SearchButton onClick={this.handleSearch} type="submit">
							<img src={AssetImageUrl["ic_search@3x.png"]} width={18} />
						</SearchButton>
					</SearchItem>
				</Header>
				<SearchKey>
					{recentSearchList.length > 0 ? (
						<div>
							<RecentHeader>
								<span>{gettext("Recent Searches")}</span>
								<Clear onClick={this.clearRecent}>
									<img src={AssetImageUrl["ic_clear@3x.png"]} width={18} />
									<span>{gettext("Clear")}</span>
								</Clear>
							</RecentHeader>
							<HistoryKeys>
								{recentSearchList.map((item, index) => {
									return (
										<div key={index} onClick={() => this.goSearch(item)}>
											{item}
										</div>
									);
								})}
							</HistoryKeys>
						</div>
					) : null}
					{topKeyWords.length > 0 ? (
						<div>
							<RecentHeader>
								<span>{gettext("Top Keywords")}</span>
							</RecentHeader>
							<TopList>
								{topKeyWords.map((item, index) => {
									return (
										<div
											key={index}
											onClick={() => this.goSearch(item.keywords, "2")}
										>
											<TopIndex red={!!item.markRed}>{index + 1}</TopIndex>
											<Words>{item.keywords}</Words>
											<WorldsArrow
												src={AssetImageUrl["ic_箭头@3x.png"]}
												width={14}
											/>
										</div>
									);
								})}
							</TopList>
						</div>
					) : null}
				</SearchKey>
				{/* 搜索联想列表 */}
				{showResult && (
					<ResultList>
						{keywords.map((item, index) => {
							return (
								<div key={index} onClick={() => this.goSearch(item.keyword)}>
									{item.isLocalHistory && (
										<LocalIcon
											src={AssetImageUrl["ic_time@3x.png"]}
											width={18}
										/>
									)}
									<AutoWords>{item.keyword}</AutoWords>
									<WorldsArrow src={AssetImageUrl["ic_箭头@3x.png"]} width={14} />
								</div>
							);
						})}
					</ResultList>
				)}
			</Container>
		);
	}
}

export default Search;
